// extracted by mini-css-extract-plugin
export default {"primaryColor":"#5bad72","primaryColorWithAlpha":"rgba(247,93,190,.1019607843)","mainBgColor":"#5bad72","secondBgColor":"#fbfbfb"};